module.exports = __webpack_public_path__ + "static/media/sandclock_orange.af53e11e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gifs/sandclock_orange.gif
// module id = 716
// module chunks = 11